import { TUseLinkedTagsForAssetProps } from '@/shared/features/tags/hooks/use-linked-tags-for-asset/use-linked-tags-for-asset.types';
import { useReadLinkedTagsForAssetQuery } from '@/shared/redux/api/assets/tags/tags-api';

export const useLinkedTagsForAsset = ({
  assetType,
  assetId,
}: TUseLinkedTagsForAssetProps) => {
  const {
    data,
    isLoading: _isLoading,
    isFetching,
  } = useReadLinkedTagsForAssetQuery(
    {
      assetId: assetId!,
      assetType: assetType!,
    },
    {
      skip: !assetId || !assetType,
    },
  );

  const tags = data?.readLinkedTagsForAsset?.items ?? [];

  return {
    tags,
    tagNames: tags.map(({ name }) => name),
    isLoading: _isLoading || isFetching,
  };
};
